import { QueryType } from '../apollo/graphqlSchema';
import { ICohortSampleAnalysis } from '../apollo/responseTypes';
import { assertNotNil } from '../types';
import { IParsedChartDataCohortSample } from '../../components/Chart/interfaces';

export default ({
  data,
}: ICohortSampleAnalysis): IParsedChartDataCohortSample => {
  assertNotNil(data);
  const { subjectName, tables, summary } = data;
  return {
    queryType: QueryType.CohortSample,
    data: {
      subjectName,
      tables,
      summary,
    },
  };
};
